export default __webpack_public_path__ + "static/media/Team_01.ee557d1a.jpg";